export default class DashboardController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmiter = EventEmitter;
    }
}



// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.controller.js